import { getRegisterFunction } from '../../utils/register.js';
import { OneUxMessageElement } from './OneUxMessageElement.js';
export const register = getRegisterFunction(OneUxMessageElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-message': OneUxMessageElement;
    "message-c80e45197f59338b741f2e78abca8f81": OneUxMessageElement;
  }
}